import { Stack, Title } from '@mantine/core'
import { SurveyTab } from '@/pages/website/index'

export default function SurveyPage() {
  return (
    <Stack>
      <Title order={2}>Судалгаа</Title>
      <SurveyTab />
    </Stack>
  )
}
